(function() {
  var ASPECT_RATIOS = ['9 / 16', '1 / 1', '16 / 9']; // portrait, square, landscape

  function randomizeContainer(el) {
    var ratio = ASPECT_RATIOS[Math.floor(Math.random() * ASPECT_RATIOS.length)];
    el.style.aspectRatio = ratio;
  }

  function patchJuniperLink(el) {
    if (el.tagName !== 'A' || !el.classList.contains('juniper-video')) return;
    if (el.getAttribute('href')) return;
    var embedUrl = el.getAttribute('data-video-url') || '';
    var match = embedUrl.match(/player\/v1\/(\d+)/);
    if (match && match[1]) {
      el.setAttribute('href', 'https://www.tiktok.com/video/' + match[1]);
      el.addEventListener('click', function(e) { e.preventDefault(); });
    }
  }

  function processAddedNodes(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType !== 1) continue;
      if (node.classList && node.classList.contains('juniper-container')) {
        randomizeContainer(node);
      }
      var nested = node.querySelectorAll ? node.querySelectorAll('.juniper-container') : [];
      for (var j = 0; j < nested.length; j++) {
        randomizeContainer(nested[j]);
      }
      patchJuniperLink(node);
      var links = node.querySelectorAll ? node.querySelectorAll('a.juniper-video') : [];
      for (var k = 0; k < links.length; k++) {
        patchJuniperLink(links[k]);
      }
    }
  }

  function setupFeedObserver(feed) {
    var existing = feed.querySelectorAll('.juniper-container');
    for (var i = 0; i < existing.length; i++) {
      randomizeContainer(existing[i]);
    }
    var existingLinks = feed.querySelectorAll('a.juniper-video');
    for (var j = 0; j < existingLinks.length; j++) {
      patchJuniperLink(existingLinks[j]);
    }

    // React to each tile Mintty inserts dynamically
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        processAddedNodes(mutations[i].addedNodes);
      }
    });
    observer.observe(feed, { childList: true, subtree: true });

    // Stop watching after Mintty finishes loading
    setTimeout(function() { observer.disconnect(); }, 15000);
  }

  function init() {
    var feed = document.getElementById('mintty-tiktok-feed');
    if (feed) {
      setupFeedObserver(feed);
      return;
    }
    // Feed not in DOM yet — watch body until it appears
    var bodyObserver = new MutationObserver(function() {
      var found = document.getElementById('mintty-tiktok-feed');
      if (found) {
        bodyObserver.disconnect();
        setupFeedObserver(found);
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
